import React, { useState } from 'react';
import { ContentHeader, Table } from '@app/shared';
import { AddUpdateRate } from './AddUpdateRate';
import { useBankOfEnglandBaseRates } from '@app/sdk';
import { ComponentErrorBoundary, toFormattedDate, toFormattedRate } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';

export function Rates() {
  const [selectedRate, setSelectedRate] = useState(undefined as any);
  const { data: rates, isLoading } = useBankOfEnglandBaseRates();
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'rate', headerName: 'Rate', valueFormatter: (params) => toFormattedRate(params.value) },
    {
      field: 'announcementDate',
      headerName: 'Announcement Date',
      valueFormatter: (params) => toFormattedDate(params.value),
    },
    { field: 'effectiveDate', headerName: 'Effective Date', valueFormatter: (params) => toFormattedDate(params.value) },
    { field: 'createdDate', headerName: 'Created Date', valueFormatter: (params) => toFormattedDate(params.value) },
    {
      field: 'lastUpdatedDate',
      headerName: 'Last Updated Date',
      valueFormatter: (params) => toFormattedDate(params.value),
    },
  ];

  const master = (
    <>
      <ContentHeader>
        Bank of England Base Rate
        <button className={`ui button`} onClick={() => setSelectedRate(null)} type="button" disabled>
          Add Rate
        </button>
      </ContentHeader>

      <div style={{ height: '600px' }}>
        <Table items={rates} onSelectItem={(rate) => setSelectedRate(rate)} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = <AddUpdateRate selectedRate={selectedRate} />;

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && rates && <MasterDetailLayout master={master} detail={detail} />}
    </ComponentErrorBoundary>
  );
}
